import React, { useState } from 'react';
const InnerHTMLTable = (data) => {
    
  const encodedHtml = `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
      /* Global styles for table, td, and other classes */
      table {
          border-spacing: 0px;
        }
        
        td {
          border: solid 1px gray;
          padding: 4px;
          font-size: 12pt;
          /* background: white; */
        }
        
        .blue {
          background-color: #DAE9F8 !important;
        }
        .header td{
          background: wheat;
        }
        .dateheader {
          font-weight: bold;
        }
        
        .header {
          font-size: 14pt;
          font-weight: bold;
        }
        
        .answer {
          text-align: right;
        }
        
      </style>
    </head>
    <body>
    ${data?.data}
    </body>
  </html>
`;



  const styles = {
    table: {
      borderSpacing: '0px',
    },
    td: {
      border: 'solid 1px gray',
      padding: '4px',
      fontSize: '12pt',
    },
    blue: {
      backgroundColor: '#DAE9F8',
    },
    dateheader: {
      fontWeight: 'bold',
    },
    header: {
      fontSize: '14pt',
      fontWeight: 'bold',
    },
    answer: {
      textAlign: 'right',
    },
  };
  const decodeHtml = (encodedStr) => {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = encodedStr;
    return textArea.value;
  };


  return (
    <div style={{marginTop :20}}>
      <div dangerouslySetInnerHTML={{ __html: encodedHtml }} />
    </div>
  );
};

export default InnerHTMLTable;
